import React from "react";
import {Descriptions, Drawer, Space} from "antd";
import {DrawerProps} from "antd/lib/drawer";
import * as minio from "../../utils/minio";
import dayjs from "dayjs";
import Styles from "./detailDrawer.module.css";


interface Props extends DrawerProps {
    bulletin?: any
}

function DetailDrawer(props: Props) {

    const {bulletin = {}, ...otherProps} = props

    return (
        <Drawer width={1200} {...otherProps} title={bulletin.title}>
            <Descriptions bordered column={2}>
                <Descriptions.Item label={'发布部门'}>
                    {bulletin.department || ''}
                </Descriptions.Item>
                <Descriptions.Item label={'发布日期'}>
                    {bulletin.publishTime && dayjs(bulletin.publishTime).format('lll')}
                </Descriptions.Item>
                <Descriptions.Item label={'加盟商发布范围'} span={2}>
                    {bulletin.type === 0 ? '全部' : bulletin.dealersName}
                </Descriptions.Item>
                {bulletin.attachments && (
                    <Descriptions.Item label={'附件'} span={2}>
                        <Space>
                            {bulletin.attachments.map((item: any) => (
                                <a target='_blank' href={minio.getUrl(item)}>{item.split('/').pop()}；</a>
                            ))}
                        </Space>
                    </Descriptions.Item>
                )}
                <Descriptions.Item label={'发布内容'} span={2}>
                    <div className={Styles.content} dangerouslySetInnerHTML={{__html: bulletin.content}}/>
                </Descriptions.Item>
            </Descriptions>
        </Drawer>
    )
}

export default DetailDrawer
